export default {
  PostComment: 'Comments',
  MentionComment: 'Comments in mentions',
  ExternalComment: 'External comments',
  ReviewComment: 'Comments in reviews',
  VisitorComment: 'Visitor post comment',
  Mention: 'Mentions',
  Review: 'Reviews',
  Post: 'Proprietary posts',
  VisitorPost: 'Visitor posts',
  Inbox: 'Inbox',
  Story: 'Story',
  Reels: 'Reels',
};
